import getters from '~/store/modules/shared/dealers/site/error/getters'
import mutations from '~/store/modules/shared/dealers/site/error/mutations'
import state from '~/store/modules/shared/dealers/site/error/state'
import { createModule } from '~/factories/store'

export default createModule({
  getters,
  mutations,
  state
})
